<!--AI文生图-->
<template>
  <div class="wsVideo-container">
    <div class="tsv-title" :style="{ color: theme.worksColor2 }">AI文生图</div>

    <div class="ts-video-info-box flex">
      <div class="ts-left-box">

        <div class="gd-box">
          <div class="ts-part2 ">
            <div class="">
              <div><span style="color: red">*</span>画面描述</div>
              <div class="no-xq-box">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请描述你想生成的图片内容"
                  v-model="content">
                </el-input>
              </div>
            </div>
            <div class="cy-handle-box flex ac jfe">
              <div class="handle-box cr" @click="handleCyDel()">
                <i class="el-icon-delete"></i>
              </div>
              <!-- <div class="handle-box cr" @click="handleCySave">-->
              <!-- <i class="el-icon-document-checked"></i>-->
              <!-- </div>-->

            </div>

            <div class="part1-md2 mt15">
              <div class="title2 flex ac jb">
                <p>推荐尝试</p>
                <div class="part1-md3 flex ac">
                  <div v-for="(item, index) in tjList" :key="index" class="every-md3-img te cr"
                       @click="handleUseTj(item)">
                    {{item.title}}
                  </div>

                </div>
                <div class="refresh flex ac jc cr" @click="getgImagePrompt">
                  <i class="el-icon-refresh" style="color: #01FBF5;font-size: 15px"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="title-ms"><span style="color: red">*</span> 图片比例</div>
          <div class="ts-part3 flex ac">
            <div class="flex ac ml15">
              <div class="every-bl-box" :class="aspect_ratio=='16:9'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('16:9')">
                <div class="oneLl"></div>
                <p>16:9</p>
              </div>
              <div class="every-bl-box" :class="aspect_ratio=='9:16'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('9:16')">
                <div class="twoLl"></div>
                <p>9:16</p>
              </div>
              <div class="every-bl-box" :class="aspect_ratio=='1:1'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('1:1')">
                <div class="threeLl"></div>
                <p>1:1</p>
              </div>
              <div class="every-bl-box" :class="aspect_ratio=='2:3'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('2:3')">
                <div class="fourLl"></div>
                <p>2:3</p>
              </div>
            </div>
          </div>

          <div class="swz-box">
            <div class="title1">参考图片 <span style="color: #EEEEEEAA">（非必填）</span></div>
            <div class="ts-part1">
              <div class="part1-tip1 tc">图片不超过 10MB，尺寸不小于 300</div>
              <div class="part1-md1 flex ac jc">
                <div v-if="!upImageUrl" class="pic-s">
                  <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/ts19.1_Icon_1.png" alt="">
                  <div class="flex ac jc">
                    <el-upload
                      ref="upload"
                      :action="uploadUrl"
                      :show-file-list="false"
                      accept=".png,.jpg,.jpeg"
                      :on-success="handleFileUpSuccess"
                      :on-error="handleFileUpError"
                      :on-remove="handleRemove"
                      :before-upload="beforeAvatarUpload"
                      multiple
                      :limit="1"
                      :headers="myHeaders"
                      :data="needParam"
                    >
                      <template>
                        <p><span>本地上传</span>参考图</p>
                      </template>
                    </el-upload>
                  </div>
                </div>
                <div v-else class="has-img" @mouseenter="showClickEvent" @mouseleave="hideClickEvent"
                     :style="{backgroundImage: 'url(' + upImageUrl + ')', backgroundRepeat:'no-repeat'}">
                  <div v-if="showButton" class="flex ac jc cr">
                    <i class="el-icon-delete hover-color" @click="handleDel()"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="title-ms"><span style="color: red">*</span> 图片数量</div>
          <div class="ts-part3 flex ac">
            <div class="flex ac ml15">
              <div class="every-pic-box" :class="imageNum == 1 ? 'every-choose-active-box':''"
                   @click="handleChooseNum('1')">
                <div class="oneLl"></div>
                <p>1张</p>
              </div>
              <div class="every-pic-box" :class="imageNum == 2 ? 'every-choose-active-box':''"
                   @click="handleChooseNum('2')">
                <div class="twoLl"></div>
                <p>2张</p>
              </div>
              <div class="every-pic-box" :class="imageNum == 3 ? 'every-choose-active-box':''"
                   @click="handleChooseNum('3')">
                <div class="threeLl"></div>
                <p>3张</p>
              </div>
              <div class="every-pic-box" :class="imageNum== 4 ? 'every-choose-active-box':''"
                   @click="handleChooseNum('4')">
                <div class="fourLl"></div>
                <p>4张</p>
              </div>
            </div>
          </div>


        </div>


        <div class="ts-part4 flex ac jc">
          <div class="btn-hc cr" @click="handleJLCreate('')">立即生成 <span class="fs15">({{needJf}}积分)</span></div>
        </div>

      </div>
      <div class="ts-middle-box">

        <div class="has-video-box" v-if="chooseImageList.length>0">
          <div class="video-part1 flex ac fw jc">
            <div class="every-image" v-for="(item,index) in chooseImageList"
                 @mouseover="hoverIndex = index"
                 @mouseleave="hoverIndex = null" :key="index" @click="dialogVisible = true">
              <img :src="item" alt=""
                   :class="aspect_ratio=='16:9'? 'img-ratio1':aspect_ratio=='9:16' ? 'img-ratio2': aspect_ratio=='2:3' ?'img-ratio3' : ''">
              <i v-if="hoverIndex==index" class="el-icon-download down-icon cr fs18"
                 @click.stop="handleDownVideo(item)"></i>
            </div>
          </div>
        </div>
        <div class="no-video-info flex jc colu" v-else>
          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/ts18.1_Icon_3.png" alt="">
          <p>快去生成你的创意吧~</p>
        </div>
        <div class="tip-box">
          内容由人工智能模型生成，不代表平台的观点、立场或态度，请合理友善地使用生成内容~
        </div>
      </div>
      <div class="ts-right-box">
        <div class="ts-part5 flex ac jb">
          <p>生成历史</p>
          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/16.1_Icon_6.png" alt="">
        </div>
        <div class="no-history cr" v-if="videoList.length<=0">
          暂无记录
        </div>
        <div class="has-video cr" v-else>
          <div class="proceed-ing flex ac jc colu bbox" v-for="(item,index) in videoList" :key="index"
               :class="choosedViedoId==item.id?'video-active': ''" @click="chooseVideo(item)">
            <div class="" v-if="item.status!=3 && item.status!=4">
              <i class="el-icon-loading mb05"></i>
              <p>图片生成中...</p>
            </div>
            <div class="fail-video flex ac colu jc" v-if="item.status==4">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/Icon_Failed.png" alt="">
              <p>图片生成失败</p>
              <p class="fail-del-box" @click="handleFailDel(item)">
                <i class="el-icon-delete"></i>
              </p>
            </div>
            <div class="success-video cr bbox" v-if="item.status==3">
              <img :src="item.url[0]" alt="cover">
              <p class="time-text" @click.stop="handleFailDel(item)">
                <i class="el-icon-delete"></i>
              </p>
              <p class="down-box" @click.stop="handleDownAll(item.url)">
                <i class="el-icon-download"></i>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <el-dialog
      title="图片浏览"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div class="">
        <Carousel :slides="chooseImageList" :interval="2000"/>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import {
    uploadComplete, gImagePrompt, videoPrompt,
    getImageGenerate, postImageGenerate, delImageGenerate,
    postUserPrompt, delUserPrompt, uploadSign,
  } from '../api/user'
  import {throttle} from "../../utils";
  import Carousel from '../components/Carousel.vue';

  export default {
    name: '',
    components: {
      Carousel,
    },
    data() {
      return {
        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        upImageUrl: '',
        showButton: false,
        tjList: [],
        content: '',
        isComposing: false,
        savedRange: null, // 用于保存光标位置
        buttonCount: 0,
        lgList: [],
        promptList: [],
        hasPopover: false,
        choosedLgList: [],
        chooseck: false,
        lgTitle: 1,
        // 接口需要参数
        prompt: '',
        negative_prompt: '',
        cfg_scale: 0.5,
        mode: 'std',
        duration: '5',
        aspect_ratio: '1:1',
        imageNum: 1,
        searchText: '',
        timeout: null,
        ysList: [],
        dialogVisible: false,
        ysTitle: '',
        ysContent: '',
        hoverIndex: null,
        videoList: [],
        choosedViedoId: null,
        chooseImageList: [],
        pollingInterval: null,
        needJf: 10,


      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      this.getUploadSign()
      this.getgImagePrompt()
      this.getVideoPrompt()
      this.ggetImageGenerate()
    },
    methods: {
      getUploadSign() {
        uploadSign({file_type: 'image'}).then(res => {
          this.uploadUrl = res.data.host
          this.uploadDir = res.data.dir
          this.needParam = {
            'OSSAccessKeyId': res.data.access_key_id,
            'policy': res.data.policy,
            'signature': res.data.signature,
          }
        })
      },
      showClickEvent() {
        this.showButton = true;
      },
      hideClickEvent() {
        this.showButton = false;
      },
      handleDel() {
        this.upImageUrl = ''
      },
      // 查询作品
      ggetImageGenerate() {
        getImageGenerate({type: 'text'}).then(res => {
          // console.log('res', res)
          this.videoList = res.data.list
        })
      },
      chooseVideo(item) {
        if (item.status == 3) {
          this.choosedViedoId = item.id
          this.chooseImageList = item.url
        }
        if (item.status == 4) {
          this.choosedViedoId = item.id
          this.chooseImageList = ''
        }
        this.content = item.text
        this.aspect_ratio = item.ratio
        this.imageNum = item.num
        this.upImageUrl = item.image
      },

      // 下载图片
      async handleDownVideo(item) {
        const response = await fetch(item);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = new Date().getTime() + '.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      // 下载所有图片
      async handleDownAll(item) {
        if (item.length > 0) {
          for (let i = 0; i < item.length; i++) {
            const response = await fetch(item[i]);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = new Date().getTime() + '.png';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }
        }
      },


      getVideoPrompt() {
        videoPrompt().then(res => {
          this.promptList = res.data
        })
      },
      getgImagePrompt() {
        gImagePrompt({type: 'text'}).then(res => {
          this.tjList = this.getRandomThree(res.data)
        })
      },
      // 清空创意
      handleCyDel() {
        this.content = ''
        this.choosedLgList = []
      },
      // 保存创意
      handleCySave() {
        postUserPrompt({content: this.content}).then(res => {
          this.$message.success(res.msg)
        }).catch(error => {
          this.$message.error(error.msg)
        })
      },
      // 使用推荐尝试
      handleUseTj(val) {
        this.content = val.content
      },
      getRandomThree(arr) {
        // 检查数组长度是否大于 3
        if (arr.length <= 3) {
          return result;
        } else {
          // 创建一个新数组用于存储随机结果
          const result = [];
          const copy = [...arr]; // 复制原数组，避免修改原数组
          // 随机取出 3 个元素
          for (let i = 0; i < 3; i++) {
            const randomIndex = Math.floor(Math.random() * copy.length); // 随机索引
            result.push(copy[randomIndex]); // 将随机元素加入结果数组
            copy.splice(randomIndex, 1); // 从复制数组中移除已选元素
          }
          return result;
        }
      },
      // 删除失败图片
      handleFailDel(item) {
        this.$confirm('此操作将永久删除该组图片, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delImageGenerate({id: item.id}).then(res => {
            this.$message.success(res.msg)
            this.ggetImageGenerate()
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 删除图片
      handleDelVideo() {
        this.$confirm('此操作将永久删除该条图片, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delImageGenerate({id: this.choosedViedoId}).then(res => {
            this.$message.success(res.msg)
            this.ggetImageGenerate()
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 选择我的预设
      chooseMyys(item) {
        this.content = item.content
        this.choosedLgList = []
      },
      // 删除预设
      handleDelYs(item) {
        this.$confirm('此操作将永久删除该条预设, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delUserPrompt({id: item.id}).then(res => {
            this.$message.success(res.msg)
            this.performSearch()
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },

      beforeAvatarUpload(file) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        const that = this
        var file_type = file.name.split('.').slice(-1)
        var file_name = that.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
          .random() * 100) + '.' + file_type
        that.needParam.key = file_name
        that.uploadSize = file.size

        const fileExtension = file.name.split('.').pop().toLowerCase()
      },
      handleFileUpSuccess(file) {
        const url = `${this.uploadUrl}/${this.needParam.key}`
        uploadComplete({
          file_type: 'image',
          size: this.uploadSize,
          url: url
        }).then(res => {
          if (res.data.url && res.data.file_id) {
            this.file_id = res.data.file_id
            this.upImageUrl = res.data.url
            this.$message.success('上传成功')
            this.loading.close();
          }
        }).catch(() => {
          this.loading.close();
        })

        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleRemove() {
        this.upImageUrl = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleResetUp() {
        this.upImageUrl = ''
        this.file_id = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },

      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },

      handleChooseMode(val) {
        this.mode = val
      },
      handleChooseDuration(val) {
        this.duration = val
      },
      handleChooseAspect(val) {
        this.aspect_ratio = val
      },
      handleChooseNum(val) {
        this.imageNum = val
        this.needJf = val * 1 * 10
      },
      handleJLCreate: throttle(function () {
        if (!this.content) {
          this.$message.error('请输入描述词！')
          return false
        }
        this.$confirm('此操作将进行AI图片创作, 是否继续?', '提示（请勿重复提交）', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.handleCreate();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }, 1000),
      handleCreate() {
        const obj = {
          type: 'text',
          text: this.content,
          image: this.upImageUrl,
          ratio: this.aspect_ratio,
          num: this.imageNum,
        }
        postImageGenerate({...obj}).then(() => {
          this.$message.success('提交成功')
          this.handleCyDel()
          this.ggetImageGenerate()
          this.$store.dispatch('updatePoints')
        }).catch(error => {
          this.$message.error(error.msg)
        })

      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {

      this.pollingInterval = setInterval(this.ggetImageGenerate, 15000);
    },
    beforeDestroy() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    }
  }
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
    padding: 0;
  }

  .wsVideo-container {
    height: 100vh;
    width: 100%;
    position: relative;

    .tsv-title {
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF80;
      margin: 22px 40px;
    }
  }

  .ts-video-info-box {
    width: 1640px;
    height: 82vh;
    background: #191B2F;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    margin: 0 auto;
    font-size: 14px;
  }

  .ts-left-box {
    width: 400px;
    height: 100%;

    background: #191B2F;
    border-radius: 12px 0px 0px 12px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;

    .gd-box::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    .gd-box {
      height: calc(100% - 110px);
      overflow-y: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
    }


    .ts-left-header {
      width: 368px;
      height: 36px;
      background: rgba(255, 255, 255, 0.04);
      border-radius: 6px;
      margin: 16px auto 24px;

      .header1, .header2, .header3 {
        cursor: pointer;
        width: 50%;
        font-weight: 500;
        font-size: 14px;
        color: #EEEEEE80;
        line-height: 36px;
        text-align: center;
      }

      .active {
        color: #04C9C9 !important;
      }

      .header2 {
        position: relative;
      }

      .header2::before {
        position: absolute;
        z-index: 1;
        content: '';
        width: 1px;
        height: 14px;
        top: 11px;
        left: 0;
        background: #4A4B5B;
      }

      /*.header2::after {*/
      /*  position: absolute;*/
      /*  z-index: 1;*/
      /*  content: '';*/
      /*  width: 1px;*/
      /*  height: 14px;*/
      /*  top: 11px;*/
      /*  right: 0;*/
      /*  background: #4A4B5B;*/
      /*}*/
    }

    .title1 {
      width: 368px;
      margin: 24px auto 12px;
    }

    .ts-part1 {
      width: 368px;
      height: 183px;
      background: rgba(255, 255, 255, 0.02);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin: 0 auto;
      padding: 16px;

      .part1-tip1 {
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF4d;
        text-align: center;
        margin-bottom: 12px;
      }

      .part1-md1 {
        .pic-s, .pic-w {
          width: 156px;
          height: 120px;
          background: #0D1027;
          border-radius: 6px;

          img {
            width: 32px;
            height: 32px;
            display: block;
            margin: 28px auto 5px;
          }

          p {
            text-align: center;
            color: #FAFAFAAA;
            font-size: 12px;

            span {
              cursor: pointer;
              font-weight: 400;
              color: #01FBF5;
              line-height: 22px;
              text-decoration-line: underline;
            }
          }
        }

        .zz-img {
          width: 24px;
          height: 24px;
          display: block;
          margin: 0 4px;
        }

        .has-img {
          width: 156px;
          height: 120px;
          background-size: contain;
          background-position: center;
          border-radius: 6px;
          padding: 50px;

          .hover-color:first-child {
            margin-right: 12px;
          }

          .hover-color {
            font-size: 18px;
          }

          .hover-color:hover {
            color: #01FBF5; /* 悬停时的颜色 */
          }
        }
      }

      .part1-md2 {
        margin: 15px 0 11px;

        .title2 {
          font-weight: 400;
          font-size: 12px;
          color: #EEEEEE80;
        }

        .refresh {
          width: 24px;
          height: 24px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 6px;
        }
      }


    }

    .part1-md3 {
      width: 260px;

      .every-md3-img {
        max-width: 120px;
        padding: 0 8px;
        height: 24px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
        margin-right: 8px;

        font-weight: 400;
        font-size: 12px;
        color: #EEEEEE;
        line-height: 24px;
        text-align: center;
      }
    }

    .ts-part2 {
      width: 368px;
      margin: 12px auto;

      .cy-input-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .cy-input-box {
        position: relative;
        font-size: 14px;
        width: 100%;
        height: 220px;
        padding: 10px 15px;
        background: #1f2237;
        color: #fff;
        border-radius: 4px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* 对于IE和Edge */
        scrollbar-width: none; /* 对于FireFox */
        .editBox {
          width: 100%;
          height: 100%;
        }

        .placeholder-box {
          position: absolute;
          width: 100%;
          z-index: 1;
          color: #727485;
          pointer-events: none;
          font-size: 14px;
          top: 15px;
        }
      }

      .cy-handle-box {
        height: 30px;
        padding: 20px 15px;
        background: #1f2237;
        color: #fff;
        border-radius: 4px;

        .handle-box {
          width: 40px;
          height: 24px;
          background: #191B2F;
          border-radius: 6px;
          line-height: 24px;
          text-align: center;
        }
      }

      .ck-active {
        color: #6C14FF;
        font-weight: 600;
      }
    }

    .title-ms {
      margin: 15px;
      font-size: 14px;
    }

    .ts-part3 {
      color: #EEEEEEB3;
      width: 368px;
      /*margin: 0 auto 12px;*/

      .every-choose-box {
        cursor: pointer;
        width: 83px;
        height: 36px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 6px;

        font-weight: 400;
        font-size: 14px;
        color: #EEEEEEAA;
        line-height: 36px;
        text-align: center;
        margin-right: 12px;
      }

      .every-choose-active-box {
        border: 2px rgb(108, 20, 255) solid;
        color: #EEEEEE;
      }

      .every-bl-box {
        cursor: pointer;
        width: 83px;
        height: 72px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 6px;
        margin-right: 12px;
        text-align: center;

        .oneLl {
          margin: 15px auto 10px;
          width: 32px;
          height: 18px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(250, 250, 250, 0.2);
        }

        .twoLl {
          margin: 10px auto 6px;
          width: 18px;
          height: 32px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .threeLl {
          margin: 14px auto 6px;
          width: 28px;
          height: 28px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .fourLl {
          margin: 14px auto 6px;
          width: 18px;
          height: 27px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
      }

      .every-pic-box {
        cursor: pointer;
        width: 83px;
        height: 40px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 6px;
        text-align: center;
        line-height: 40px;
        margin-right: 12px;
      }
    }


    .no-xq-box {
      background: #1f2237;
      width: 368px;
      margin: 12px auto 0;
    }

    .ts-part4 {
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: 400px;
      height: 96px;
      background: #191B2F;
      border-radius: 0px 0px 0px 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      border-right: 1px solid rgba(255, 255, 255, 0.1);

      .btn-hc {
        width: 352px;
        height: 48px;
        background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
        border-radius: 8px;

        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
      }
    }
  }

  .ts-middle-box {
    width: 1033px;
    height: 100%;

    .no-video-info {
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFFAA;
      text-align: center;
      margin-bottom: 250px;

      img {
        display: block;
        width: 99px;
        height: 85px;
        margin: calc(41vh - 80px) auto 23px;
      }
    }

    .has-video-box {
      width: 620px;
      height: 610px;
      background: #1f2237;
      margin: 30px auto 0;
      border-radius: 6px;

      .video-part1 {
        width: 620px;
        height: 610px;
        background: #1f2237;
        padding: 20px;

        .every-image {
          position: relative;
        }

        .down-icon {
          position: absolute;
          z-index: 9;
          bottom: 20px;
          right: 20px;
        }

        img {
          cursor: pointer;
          display: block;
          border-radius: 6px;
          width: 280px;
          height: 280px;
          object-fit: fill;
          margin-bottom: 10px;
          margin-right: 10px;
        }

        .img-ratio1{
          width: 280px;
          height: 158px;
        }
        .img-ratio2{
           width: 158px;
           height: 280px;
        }
        .img-ratio3{
          width: 187px;
          height: 280px;
        }
      }

      .video-part2 {
        width: 800px;
        height: 60px;
        background: #1f2237;
        border-radius: 16px;

        .handle-box {
          width: 50px;
          height: 30px;
          background: #191B2F;
          border-radius: 16px;
          line-height: 30px;
          text-align: center;
          margin-right: 15px;
        }

      }
    }

    .tip-box {
      text-align: center;
      color: #c5c7d5AA;
      font-size: 13px;
      margin-top: 50px;
    }
  }
  .ts-right-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .ts-right-box {
    width: 183px;
    height: 100%;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    background: #191B2F;
    border-radius: 12px 0px 0px 12px;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    padding: 26px 16px;

    .ts-part5 {
      font-weight: 500;
      font-size: 16px;
      color: #EEEEEE;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .no-history, .proceed-ing {
      margin-top: 16px;
      width: 153px;
      height: 120px;
      background: #26283B;
      border-radius: 12px;
      line-height: 120px;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFFAA;
      text-align: center;
    }

    .proceed-ing {
      line-height: 20px;
    }

    .video-active {
      border: 2px #6c14ff solid;
      color: #EEEEEE;
    }

    .success-video {
      width: 153px;
      height: 118px;
      position: relative;
      border-radius: 12px;

      img {
        width: 97%;
        height: 100%;
        object-fit: contain;
        border-radius: 12px;
      }

      .time-text {
        position: absolute;
        right: 32px;
        bottom: 10px;
      }

      .down-box {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }

    .fail-video {
      width: 213px;
      height: 120px;
      position: relative;

      img {
        width: 36px;
        height: 36px;
      }

      .fail-del-box {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }

  }


</style>
<style lang="scss">

  .custom-popover {
    background-color: rgb(48, 51, 70); /* 修改背景颜色 */
    border: none;

  }

  .custom-popover .el-popover__title {
    color: #333; /* 修改标题颜色 */
    font-size: 16px; /* 修改标题字体大小 */
  }

  .custom-popover img {
    width: 100%; /* 修改图片宽度 */
    height: auto;
    object-fit: contain;
  }

  .no-xq-box .el-textarea__inner {
    background: #1f2237 !important;
    /*border-color: rgba(255, 255, 255, 0.2);*/
    border: none !important;
    color: #FFFFFF;
  }

  .custom-popover .popper__arrow {
    border-right-color: #303346 !important;
  }

  .custom-popover .popper__arrow::after {
    border-right-color: #303346 !important;
  }

  .custom-popover2 {
    background-color: rgb(48, 51, 70) !important; /* 修改背景颜色 */
    border: none !important;
  }

  .custom-popover2 .popper__arrow {
    border-top-color: #303346 !important;
  }

  .custom-popover2 .popper__arrow::after {
    border-top-color: #303346 !important;
  }

  .custom-popover {
    .lg-title-box {
      padding: 10px;
      width: 100%;
      font-size: 15px;
      color: #ffffff4d;
    }

    .lg-title-active {
      color: #ffffff;
      border-bottom: 2px solid #6C13FF;
    }

    .ling-gan-pro {
      width: 100%;

      .every-lg-box {
        cursor: pointer;
        padding: 4px 12px;
        color: #ffffff4d;
        margin-right: 12px;

        p {
          margin-bottom: 10px;
        }

        .every-ele-box {
          height: 24px;
          background: rgba(255, 255, 255, 0.05);
          margin: 0 10px 8px 0;
          border-radius: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #EEEEEE;
          line-height: 24px;
          text-align: center;

          .every-lg-p {
            padding: 0 8px;
            border-radius: 4px;
          }

          .choosed-active-lg {
            color: #E3D4FC;
            background: #6C14FF4d;
          }
        }
      }
    }
    .my-ys-box::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    .my-ys-box {
      margin: 0 10px 8px 0;
      min-height: 300px;
      max-height: 500px;
      overflow-y: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      .ys-list-box {
        margin-top: 12px;

        .every-ys-box {
          width: 100%;
          height: 80px;
          background: rgba(255, 255, 255, 0.02);
          border-radius: 6px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          margin-bottom: 12px;
          position: relative;
          padding: 8px 16px;
          font-size: 14px;

          p:first-child {
            color: #FAFAFA;
            margin-bottom: 5px;
          }

          p:last-child {
            color: #FAFAFAAA;
          }

          .del-box {
            width: 32px;
            height: 32px;
            position: absolute;
            top: 4px;
            right: 4px;
            z-index: 1;
          }
        }
      }
    }
  }

  .every-ele-box {
    video {
      width: 100%; /* 设置图片宽度 */
      height: auto; /* 保持图片比例 */
      object-fit: cover; /* 填充整个容器 */
    }

    /* 禁用控制条（如果需要进一步确保隐藏） */
    video::-webkit-media-controls {
      display: none !important;
    }

    video::-webkit-media-controls-enclosure {
      display: none !important;
    }

    video::-webkit-media-controls-panel {
      display: none !important;
    }
  }

  .deletable-button {
    color: #E3D4FC;
    background: #6C14FF4d;
    padding: 4px 16px 4px 10px;
    border-radius: 4px;
    margin: 5px;
    white-space: nowrap;

    .delete-btn {
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 0;
      margin-left: 5px;
      color: #ffffffAA;
      font-size: 12px;
      position: relative;
    }

    .delete-btn::before {
      content: '';
      position: absolute;
      z-index: 1;
      right: -10px;
      bottom: -1px;
      width: 12px;
      height: 12px;
      background-image: url('https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/wsVideoclose.png');
      background-size: cover;
    }
  }

  .my-ys-box {
    .el-input__inner {
      background: #191B2F;
      border: none;
      color: #eeeeee;
    }

    .el-button {
      background: #191B2F;
      color: #eeeeee;
      border: none;
    }

    .el-button:hover {
      color: #ffffff;
      border-color: #c6e2ff;
      background-color: #191B2F;
    }

  }

  .wsVideo-container {
    .el-dialog {
      background: #20212C;
    }

    .el-dialog__title {
      color: #ffffff;
    }

    .el-dialog__body {
      margin-top: 0;
      padding-top: 10px;
    }
  }

  .dialogInfo {
    .el-input__inner, .el-textarea__inner {
      background: transparent;
      border: 1px rgba(255, 255, 255, 0.2) solid;
      color: #eeeeee;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/wsImage.vue